export type TestimonialSource =
  | 'capterra'
  | 'g2'
  | 'google'
  | 'trustpilot'
  | 'youtube';

interface TestimonialBase {
  id: string;
  author: string;
  title?: string;
  rating?: number;
  source?: TestimonialSource;
  sourceUrl?: string;
}

export interface TextTestimonial extends TestimonialBase {
  type: 'text';
  avatarUrl: string;
  quote: string;
}

export interface VideoTestimonial extends TestimonialBase {
  type: 'video';
  videoUrl: string;
  poster: string;
  quote?: string;
}

export type Testimonial = TextTestimonial | VideoTestimonial;

export const DEFAULT_TESTIMONIAL_RATING = 5;

/**
 * Testimonials are rendered in this order. The wall automatically places each
 * card in the shortest available column, matching the former Senja widget.
 */
export const TESTIMONIALS: Testimonial[] = [
  {
    id: 'jeff-wilson',
    type: 'video',
    videoUrl: 'https://videos.easy-peasy.ai/testimonials/jeff-wilson.mp4',
    poster: 'https://media.easy-peasy.ai/testimonials/posters/jeff-wilson.webp',
    author: 'Jeff Wilson',
    title: 'By far the best compilation AI utility',
    quote: `By far the best compilation AI utility out there. Period. We have tried multiple platforms that would work for us - a small business - and it was a bit overwhelming two years ago. Easy-Peasy has been a godsend. So many freaking tools and no fewer than 10 (of the 200) are ones we use at least on a weekly basis. Ironically, their human support is one of the most appreciated elements.`,
  },
  {
    id: 'vivian-daze',
    type: 'text',
    author: 'Vivian Daze',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/vivian-daze.webp',
    title: 'Great services',
    quote:
      'Great services, and lovely and attentive customer service. Would reccommend',
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/683848a178f32255d75a2e31',
  },
  {
    id: 'cody-crabb',
    type: 'video',
    videoUrl: 'https://videos.easy-peasy.ai/testimonials/cody-crabb.mp4',
    poster: 'https://media.easy-peasy.ai/testimonials/posters/cody-crabb.webp',
    author: 'Cody Crabb',
    title: 'Great service, Best AI tool',
  },
  {
    id: 'kia-tiow-cogue',
    type: 'text',
    author: 'Kia Tiow | COGUE',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/kia-tiow-cogue.webp',
    quote:
      'Easy-peasy is an easy to pick up and awesome AI software. I love it.',
    source: 'google',
    sourceUrl:
      'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2pSRU5UTlpTMUpVZW1remEycGpWMVZwUW5GM1QyYxAB!2m1!1s0x0:0x16f24919e90571c4!3m1!1s2@1:CAIQACodChtycF9oOjRENTNZS1JUemkza2pjV1VpQnF3T2c%7C%7C?hl=en-US',
  },
  {
    id: 'easy-peasy-ai-workshop',
    type: 'video',
    videoUrl:
      'https://videos.easy-peasy.ai/testimonials/easy-peasy-ai-workshop.mp4',
    poster:
      'https://media.easy-peasy.ai/testimonials/posters/easy-peasy-ai-workshop.webp',
    author: 'Easy-Peasy AI',
    source: 'youtube',
  },
  {
    id: 'dezign121',
    type: 'text',
    author: 'Dezign121',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/dezign121.webp',
    quote:
      'Easy-Peasy.AI is very user friendly & a lot more to explore not only in the lesson, very helpful assistant in both work & personal',
    source: 'google',
    sourceUrl:
      'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT25kTlRuTnpWRUZQZVU0MVNqRjZXR0UzVGw5MVUwRRAB!2m1!1s0x0:0x16f24919e90571c4!3m1!1s2@1:CAIQACodChtycF9oOndNTnNzVEFPeU41SjF6WGE3Tl91U0E%7C%7C?hl=en',
  },

  {
    id: 'blanca-marin',
    type: 'text',
    author: 'Blanca Marin',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/blanca-marin.webp',
    title: 'Very Good AI…',
    quote: `I really liked the easy-peasy AI service. It's a great tool, but I also had to ask them for a refund because I chose the wrong plan, and they were very quick to respond to my request. They looked into my case and I got my money back without any problems. Of course, I will continue to use it for my projects.`,
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/692e2b183c258e96c195673b',
  },
  {
    id: 'easy-peasy-ai-member-feedback',
    type: 'video',
    videoUrl:
      'https://videos.easy-peasy.ai/testimonials/easy-peasy-ai-member-feedback.mp4',
    poster:
      'https://media.easy-peasy.ai/testimonials/posters/easy-peasy-ai-member-feedback.webp',
    author: 'Easy-Peasy AI',
    source: 'youtube',
  },
  {
    id: 'muhammad-md-rahim',
    type: 'text',
    author: 'Muhammad Md Rahim',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/muhammad-md-rahim.webp',
    quote:
      'Very awesome and practical AI tool that can help improve our productivity and the quality of our work!',
    source: 'google',
    sourceUrl:
      'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2xaTVZIWjBUbXhOUTNob1F6bDRkazlzYWpGMlExRRAB!2m1!1s0x0:0x16f24919e90571c4!3m1!1s2@1:CAIQACodChtycF9oOlZMVHZ0TmxNQ3hoQzl4dk9sajF2Q1E%7C%7C?hl=en',
  },
  {
    id: 'ken-poon',
    type: 'text',
    author: 'Ken Poon',
    avatarUrl: 'https://media.easy-peasy.ai/testimonials/avatars/ken-poon.webp',
    quote:
      'Very useful and true to “Easy Peasy” on using AI. One platform on all the tools required for business needs. Marianna sharing is super informative on how to use easy-peasy.ai',
    source: 'google',
    sourceUrl:
      'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT25oTVdpMVlOVEl0V0RSd1UwTXpMVlU1ZVRaVVZGRRAB!2m1!1s0x0:0x16f24919e90571c4!3m1!1s2@1:CAIQACodChtycF9oOnhMWi1YNTItWDRwU0MzLVU5eTZUVFE%7C%7C?hl=en',
  },
  {
    id: 'dennis-cambronero',
    type: 'text',
    author: 'Dennis Cambronero',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/dennis-cambronero.webp',
    title: 'I have been using the tool for +1 year…',
    quote:
      'I have been using the tool for +1 year and I have to say it is amazing. I use it to create images, bots and access every LLM in one single place. I highly recommend it.',
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/68d550f99aade05645ca815e',
  },
  {
    id: 'yeah-likes',
    type: 'text',
    author: 'Yeah Likes',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/yeah-likes.webp',
    quote:
      'Practical and Powerful Software which is all In one and versatile. Just finished their workshop and got practical and valuable tips and tricks.',
    source: 'google',
    sourceUrl:
      'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2xCeU1sTklaVzFYWkU5MGNHVklWamxZYm5JM1ZuYxAB!2m1!1s0x0:0x16f24919e90571c4!3m1!1s2@1:CAIQACodChtycF9oOlByMlNIZW1XZE90cGVIVjlYbnI3Vnc%7C%7C?hl=en',
  },
  {
    id: 'zoldi-jozsefne',
    type: 'text',
    author: 'Zöldi Józsefné',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/zoldi-jozsefne.webp',
    title: 'Masterful pictures',
    quote:
      'I have been looking for a photo editing program for a long time where I can create delicate watercolors. This is the first place where I was able to make this dream come true. The generated images can be worthy illustrations for a book, and this brings me great joy. I recommend it to everyone with love.',
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/67e6b1fc1ac271895dfe9c98',
  },
  {
    id: 'hb-radke',
    type: 'text',
    author: 'HB Radke',
    avatarUrl: 'https://media.easy-peasy.ai/testimonials/avatars/hb-radke.webp',
    title:
      'The AI tools especially the text to…Voice over and animate still photos',
    quote:
      'The AI tools especially the text to speech and ai video creation are super easy and friggin amazing. Reasonable price point and great support. Im doing a surprise video project and being able to bring photos from the 1920s to life is a friggin miracle. The only thing i wish i could do was have some control over inflection/emotion etc. but im sure that will be coming. Sign up. totally worth it.',
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/6784e5fa42869da8e00983bb',
  },
  {
    id: 'chaitanya-a',
    type: 'text',
    author: 'Chaitanya A.',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/chaitanya-a.webp',
    title: 'Best AI software',
    quote: 'The speed of implementation, is the best about the Easy-Peasy.ai',
    source: 'g2',
    sourceUrl:
      'https://www.g2.com/products/easy-peasy-ai/reviews/easy-peasy-ai-review-10566346',
  },
  {
    id: 'gabriel-s',
    type: 'text',
    author: 'Gabriel S.',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/gabriel-s.webp',
    title: 'The best AI I have discovered to date',
    quote: `This AI is revolutionary because it combines most of the useful AIs into a single tool. I constantly keep watch and so far I haven't found anything better than this tool. It's simple, it has everything. All the most useful features are gathered in Easy Peasy.`,
    source: 'g2',
    sourceUrl:
      'https://www.g2.com/products/easy-peasy-ai/reviews/easy-peasy-ai-review-10300612',
  },
  {
    id: 'julia-hewko',
    type: 'text',
    author: 'Julia Hewko',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/julia-hewko.webp',
    title: 'Super easy to use',
    quote: `Super easy to use. Love the different templates. I usually use the first output and rarely need another. It's helping my ADHD brain with productivity and reducing the barriers to making notes for my job. I decided to subscribe within moments of using it.`,
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/667db592217b7d99376c635f',
  },
  {
    id: 'andreas-geng',
    type: 'text',
    author: 'Andreas Geng',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/andreas-geng.webp',
    title: 'I searched and tried for a long time',
    quote: `I searched and tried for a long time. This offer is an all-round carefree package when it comes to AI.
An ideal multi-tool that saves me time as a journalist, is helpful and increases quality`,
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/6655e1d5f5105873ac74769f',
  },
  {
    id: 'ronit-s',
    type: 'text',
    author: 'Ronit S.',
    avatarUrl: 'https://media.easy-peasy.ai/testimonials/avatars/ronit-s.jpg',
    title: 'Easy Peasy AI a fantastic tool',
    quote: `Easy Peasy AI is a fantastic tool. The intuitive interface without needing any technical expertise. Use runs fast and the results are highly accurate. Plus, the affordable pricing plans make powerful AI accessible even for individuals and small businesses. I've been impressed with the results and would highly recommend Easy Peasy AI. It's AI made easy!`,
    source: 'g2',
    sourceUrl:
      'https://www.g2.com/products/easy-peasy-ai/reviews/easy-peasy-ai-review-9549399',
  },
  {
    id: 'ajay-g',
    type: 'text',
    author: 'Ajay G.',
    avatarUrl: 'https://media.easy-peasy.ai/testimonials/avatars/ajay-g.webp',
    title: 'A top AI provider which align with a human though too',
    quote:
      'easy-peasy AI is a prominent AI platform that caters to a wide range of users, including businesses and individuals. Their platform is designed to be user-friendly, offering access to various AI tools like chatbots and image recognition software. The seamless integration of AI technology provided by easy-peasy AI not only enhances operational efficiency but also significantly boosts productivity. The dedicated team at easy-peasy AI ensures top-notch customer support and offers customizable solutions to meet the unique needs of their users. With its intuitive interface, easy-peasy AI simplifies the utilization of AI tools, making them accessible to users of all technical levels. As a trusted and innovative AI provider, easy-peasy AI empowers users to leverage the full potential of artificial intelligence effectively for various applications.',
    source: 'g2',
    sourceUrl:
      'https://www.g2.com/products/easy-peasy-ai/reviews/easy-peasy-ai-review-9508264',
  },
  {
    id: 'nermin-s',
    type: 'text',
    author: 'Nermin S.',
    avatarUrl: 'https://media.easy-peasy.ai/testimonials/avatars/nermin-s.webp',
    title: 'Easy-Peasy.AI is an incredible chatbot platform!',
    quote: `Easy-Peasy.AI is an incredible chatbot platform! It's user-friendly, intelligent, and provides accurate and helpful responses. I'm amazed by its capabilities and how it adapts to my needs. I am highly satisfied with the service and would highly recommend it to anyone who is looking for an AI tool for their content writing needs.

It's smart, helpful, and provides accurate information. Offers 90+ copywriting templates.`,
    source: 'capterra',
    sourceUrl:
      'https://www.capterra.com/p/10002907/a/reviews/Capterra___5085156/',
  },
  {
    id: 'adetola-adeyeye',
    type: 'text',
    author: 'Adetola Adeyeye',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/adetola-adeyeye.webp',
    title: "it's so helpful and easy to use",
    quote: "it's so helpful and easy to use",
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/64f5b4e269c0bb5d561587a7',
  },
  {
    id: 'delois-p',
    type: 'text',
    author: 'Delois P.',
    avatarUrl: 'https://media.easy-peasy.ai/testimonials/avatars/delois-p.webp',
    title: 'Great AI tool',
    quote: `Great experience overall. I’ve been using AI since February.

It’s very intuitive and easy to use. Great for novice users or those wanting an AI tool that is user friendly. The prompts are a great addition.`,
    source: 'capterra',
    sourceUrl:
      'https://www.capterra.com/p/10002907/a/reviews/Capterra___4895833/',
  },
  {
    id: 'furkan-ucar',
    type: 'text',
    author: 'Furkan Uçar',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/furkan-ucar.webp',
    title:
      "Thanks for the oppAI Tool That's Making AI More Accessibleortunity to evaluate…",
    quote: `Thanks for the opportunity to evaluate Easy-Peasy AI. I enjoyed using it and think it has a lot of potential. It's easy to use, offers a variety of features, and is affordable. I would recommend it to others.

Thanks again`,
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/64947f26d67f2fbab7643dbc',
  },
  {
    id: 'robin-sedey',
    type: 'text',
    author: 'Robin Sedey',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/robin-sedey.webp',
    title: 'Easy to use, high quality outputs, time saving',
    quote:
      'I have been using this Easy-Peasy.AI for the last 2 months to help with my job searching. It is easy to use and the generations have saved me so much time and am very impressed with the quality of the outputs. Highly recommend!',
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/642444afd1f8f4233986ae11',
  },
  {
    id: 'gaurav-chandra',
    type: 'text',
    author: 'Gaurav Chandra',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/gaurav-chandra.webp',
    title: 'Ease of use and economical',
    quote: 'Ease of use and economical. They are better than others.',
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/64144df84625a5e1c9098934',
  },
  {
    id: 'jose-luis-cortes',
    type: 'text',
    author: 'José Luis Cortés',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/jose-luis-cortes.webp',
    title: "The service is great but The support it's Even better",
    quote:
      'The service is great but The support team is awesome. Every time That I need something they answear very fast and every time they have a solution for me! I AM superhappy with Marky and all the team! Thank You very much!',
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/640b3a6514181e5d4fd6c812',
  },
  {
    id: 'jeriel-rosh-pel',
    type: 'text',
    author: 'Jeriel Rosh Pel',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/jeriel-rosh-pel.webp',
    title: 'very precise and amazing site to help…',
    quote:
      'very precise and amazing site to help with your every day write-up need! highly recommended!',
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/63c3ddf94d0773066a3895c6',
  },
  {
    id: 'chelcie-s-porter',
    type: 'text',
    author: 'Chelcie S Porter',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/chelcie-s-porter.webp',
    title: 'Absolutely amazing app',
    quote:
      'Absolutely amazing app. Lightened my workload and made my day go much smoother',
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/63bfc6512338b6d417b7596e',
  },
  {
    id: 'shaun-mzcusker',
    type: 'text',
    author: 'Shaun MZcCusker',
    avatarUrl:
      'https://media.easy-peasy.ai/testimonials/avatars/shaun-mzcusker.webp',
    title: '"Marky" Will Help Your Imagintion SOAR',
    quote: `It is astonishing what AI can do for creating images! The true art is in knowing what to write in your text prompt in order to get those fabulous images. This can be a real daunting task, especially if you are new to creating images with AI, like I am.

Easy-Peasy really goes the extra mile in helping uers to get the most out of their AI experience. There's one feature there that says, "Explain it to me like I'm 5". It does just what it says! It'll walk you through what to do and how to create soectacular images you never knew was possible before!

There's also a chat there called "Marky". Marky is so helpful that you feel like you're talking to a real person. He'll listen to what it is you're trying to create. When it goes wrong, he'll explain to you why it likely happened and he's quick to give suggestions on how to fix it. I say "he" because he's that good, Marky makes you feel right at home, and will definitely help your imagination so you can create brilliant images you just can't do any other way!

Well done, Easy Peasy!`,
    source: 'trustpilot',
    sourceUrl: 'https://www.trustpilot.com/reviews/693a7ddf4d6e558682858be8',
  },
];
